import { useEffect } from 'react';

/**
 * Runs `handler` when `key` is pressed anywhere in the document.
 * Pass `enabled: false` to detach the listener.
 */
export function useOnKeyDown(key: string, handler: () => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === key) handler();
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [key, handler, enabled]);
}
